import { render } from "./VideoWallArea.vue?vue&type=template&id=58ea9833&ts=true"
import script from "./VideoWallArea.vue?vue&type=script&lang=ts"
export * from "./VideoWallArea.vue?vue&type=script&lang=ts"

import "./VideoWallArea.vue?vue&type=style&index=0&id=58ea9833&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__